import type { SortDirection } from '_BRIGHT_/generated/generated-bright-components'

export const sortDirections: Record<string, SortDirection> = {
  ASC: 'ASC',
  DESC: 'DESC',
}
